// extracted by mini-css-extract-plugin
export default {"child":"Tooltip--child--36f129","container":"Tooltip--container--c4c186","arrow":"Tooltip--arrow--f839bc"};